import {Injectable, Optional} from '@angular/core';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

export interface AppAccessControl {
	[role: string]: {
		parent?: string;
		view?: string;
		create?: string;
		edit?: string;
		remove?: string;
		[key: string]: string | undefined;
	};
}

const DEFAULT_ACCESS: AppAccessControl = {
	guest: {view: '*'},
	user: {parent: 'guest', create: '*', edit: '*', remove: '*'},
};

@Injectable()
export class AppAccessControlService {
	constructor(@Optional() private readonly roleProvider: AppRoleProvider | null) {}

	isGranted(permission: string, resource: string): Observable<boolean> {
		const role$ = this.roleProvider?.getRole() ?? of('guest');
		return role$.pipe(
			map(role => this.can(role, permission, resource)),
		);
	}

	private can(role: string, permission: string, resource: string): boolean {
		const roleConfig = DEFAULT_ACCESS[role];
		if (!roleConfig) {
			return false;
		}

		if (this.matches(roleConfig[permission], resource)) {
			return true;
		}

		if (roleConfig.parent) {
			return this.can(roleConfig.parent, permission, resource);
		}

		return false;
	}

	private matches(value: string | undefined, resource: string): boolean {
		if (!value) {
			return false;
		}
		if (value === '*') {
			return true;
		}
		return value.split(',').map(entry => entry.trim()).includes(resource);
	}
}

@Injectable()
export class AppRoleProvider {
	getRole(): Observable<string> {
		return of('guest');
	}
}
